import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StudyTransactionModel, TransactionObservationUnitModel } from '../../../../shared/inventory/service/study-transaction.model';

@Component({
    selector: 'jhi-trancation-additional-details-modal',
    templateUrl: './transaction-additional-details-modal.component.html',
    styleUrl: './transaction-additional-details-modal.component.scss'
})
export class TransactionAdditionalDetailsModalComponent {

    constructor(private activeModal: NgbActiveModal) { }

    studyTransactionModel: StudyTransactionModel;
    transactionObservationUnitModels: TransactionObservationUnitModel[];

    cancel() {
        this.activeModal.dismiss();
    }

    proceed() {
        this.activeModal.close();
    }

    trackByObsUnitId(index, item: TransactionObservationUnitModel) {
        return item.obsUnitId;
    }
}
